// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__2e8Iv","App-logo-spin":"Navbar_App-logo-spin__ayB6W"};